// extracted by mini-css-extract-plugin
export var cardLayout = "_7q-1";
export var paginationContainer = "_7q-0";